// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Link,
  InputAdornment,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
  Paper,
  IconButton,
} from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ButtonComponents from "../../commonComponents/ButtonComponents";
import { textColor } from "../../../utils/commonstyle";
import { useNavigate } from "react-router-dom";
import { postLedgerConfiguration, fetchAccountData,
} from "../../../redux/slice/ledgerSlice";
import { useDispatch, useSelector } from "react-redux";
import { generateGUID, numberToWords } from "../../../utils/formatUtils";
import { AppconfigName } from "../../../utils/config";
import Copy from "../../../assets/copy.png";
import uploadDone from "../../../assets/uploadGreen.png";
import trash from "../../../assets/trash.png";
import { paymentMasterDetails } from "../../../redux/slice/businessSlice";
import { addWireFund } from "../../../redux/slice/fundAndTransactionSlice";
import { toast, ToastContainer } from "react-toastify";
import LoadingCircular from "../../Loading";
// import FileCopyIcon from '@mui/icons-material/FileCopy';

const AddFundsBank = () => {
  const configName = AppconfigName();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [file, setFiles] = useState({});
  const { accountResponse } = useSelector((state) => state.ledger);
  const { loginInvestorId, businessId } = useSelector((state) => state.user);

  const fetchPayment = async () => {
    setLoading(true);
    const response = await dispatch(
      paymentMasterDetails("bank-details")
    ).unwrap();
    const filteredData = response.body.filter(item => 
      !item.columnName.toLowerCase().includes("escrow")
    );
    
    // Now set the filtered data
    setPaymentData(filteredData);
    setLoading(false);
  };

  useEffect(() => {
    if (businessId) {
      dispatch(fetchAccountData(businessId));
    } else {
      dispatch(fetchAccountData(loginInvestorId));
    }
  }, [loginInvestorId, businessId]);

  useEffect(() => {
    fetchPayment();
  }, []);

  const handleAddFundsBank = async () => {
    try {
      const newGUID = generateGUID();
      if (amount && !error) {
        const amt = amount.replaceAll(",", "");
        const formData = new FormData();
        formData.append("DepositReceipt", file);
        const payload = {
          investorId: loginInvestorId,
          amount: amt,
          formData,
        };
        dispatch(addWireFund(payload)).unwrap();
        setDialogOpen(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formatAmount = (value) => {
    if (value === "") return ""; // Return empty string if no value
    const numberValue = parseFloat(value);
    return isNaN(numberValue)
      ? ""
      : new Intl.NumberFormat("en-US").format(numberValue);
  };

  const handleAmountChange = (e) => {
    const input = e.target;
    const cursorPosition = input.selectionStart;
    const previousValue = amount;
    const previousLength = previousValue.length;
    
    let rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove any non-digit characters

    // Check if the value is valid (only digits, no decimals, no special characters)
    if (/^\d*$/.test(rawValue)) {
      if (rawValue === "") {
        setAmount(""); // Set the amount to empty if the value is deleted entirely
      } else {
        const formattedValue = formatAmount(rawValue);
        setAmount(formattedValue);
        
        // Calculate new cursor position
        setTimeout(() => {
          const newLength = formattedValue.length;
          let newCursorPosition = cursorPosition;
          
          // If deleting a digit
          if (previousLength > newLength) {
            // If deleting a comma
            if (previousValue[cursorPosition - 1] === ',') {
              newCursorPosition = cursorPosition - 1;
            }
            // If deleting a digit before a comma
            else if (previousValue[cursorPosition] === ',') {
              newCursorPosition = cursorPosition - 1;
            }
            // If deleting a digit after a comma
            else if (previousValue[cursorPosition - 2] === ',') {
              newCursorPosition = cursorPosition - 1;
            }
          }
          
          // Ensure cursor position is within bounds
          newCursorPosition = Math.min(Math.max(0, newCursorPosition), formattedValue.length);
          input.setSelectionRange(newCursorPosition, newCursorPosition);
        }, 0);
      }
      setError(parseInt(rawValue) <= 0); // Check if the value is less than or equal to 0
    } else {
      setError(true); // Set error if the input is invalid (contains non-numeric characters)
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setAmount(""); // Reset the amount after closing dialog
    navigate("/search");
  };

  const handleCopy = (value) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        alert("Copied to clipboard!");
      })
      .catch((err) => {
        alert("Failed to copy: " + err);
      });
  };

  const handleClick = () => {
    document.getElementById("type")?.click();
  };

  const handleDragOver = (event: React.DragEvent<HTMLElement>) => {
    event.preventDefault();
  };

  const handleDrop = (event: React.DragEvent<HTMLElement>) => {
    event.preventDefault();
    const uploadedFiles = Array.from(event.dataTransfer.files);
    if (uploadedFiles.length) {
      const changeEvent = {
        target: { files: uploadedFiles },
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      onFileChange(changeEvent, "type");
    }
  };

  const handleFileChange = async (
     event: React.ChangeEvent<HTMLInputElement>
   ) => {
     const uploadedFile = event.target.files ? event.target.files[0] : null;
    
     if (!uploadedFile) return; // Early return if no file is selected

     // Check file type
     const allowedFileTypes = ['.jpg', '.jpeg', '.png', '.pdf'];
     const fileExtension = '.' + uploadedFile.name.split('.').pop()?.toLowerCase();
     if (!allowedFileTypes.includes(fileExtension)) {
       toast.error(`File type ${fileExtension} is not allowed. Please upload only ${allowedFileTypes.join(', ')} files.`, {
         className: 'custom-toast'
       });
       event.target.value = '';
       return;
     }
 
     // Check if the file size exceeds the limit (e.g., 5MB)
     if (uploadedFile.size > 5 * 1024 * 1024) {
       // 5MB limit
       console.log(uploadedFile.size)
       toast.error("The uploaded file exceeds the maximum allowed size of 5 MB. Please upload a smaller file.", {
        className: 'custom-toast'
      });
       event.target.value = '';
       return;
     }
 
     // Set the selected file
     setFiles(uploadedFile);
   };
 

  return (
    <>
    <ToastContainer />
      {/* Success Dialog */}
      <Dialog
        open={dialogOpen}
        disableEscapeKeyDown
        aria-labelledby="success-dialog"
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <Typography align="center" sx={{ color: "#FF5C39", mb: 1 }}>
            Fund addition initiated
          </Typography>
          <DialogContentText
            align="center"
            sx={{
              color: textColor.fontColor,
              mb: 2,
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            Fund transfer of ${amount} has been initiated. We will notify you
            once they are available in your xBid account. Meanwhile, explore our
            exclusive list of foreclosure properties!
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", mb: 2, pt: 0 }}>
          <ButtonComponents
            label="Explore Properties"
            onClick={handleCloseDialog}
            variant="contained"
            sx={{
              fontSize: 14,
              px: 3,
              height: 40,
              borderRadius: 2,
              "&:hover": {
                boxShadow: "none",
              },
            }}
          />
        </DialogActions>
      </Dialog>

      {/* Main Content */}
      <Box
        sx={{
          maxWidth: { xs: "100%", md: "45%" },
          mx: "auto",
          my: 1.5,
          display: "flex",
          flexDirection: "column",
          minHeight: { xs: "80vh", md: "33.2rem" },
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 2,
          color: textColor.fontColor,
          boxShadow: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: "1.25rem", md: 24 },
            color: textColor.fontColor,
            mb: 1,
            textAlign: "center",
          }}
        >
          Add Funds
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: "1rem", md: 15 },
            color: textColor.fontColor,
            mb: 1,
            textAlign: "center",
            fontWeight: 400,
          }}
        >
          In order to add funds to your xBid account, please wire transfer to
          the account listed below.
          <br /> Once done, provide details of the transaction in the next
          section
        </Typography>
        <Box
          style={{ fontWeight: 500 }}
          fontSize={17}
          color={textColor.fontColor}
        >
          <span style={{ fontWeight: 700 }}> Step 1 </span>: Bank details for
          wire transfer
        </Box>
        {loading ? (
          <LoadingCircular height="180px" />
        ) : (
          <Box my={1}>
            <div style={{ display: "flex", flexWrap: "wrap", gap:11 }}>
              {paymentData.map((bank, index) => (
                <div
                  key={index}
                  style={{
                    width: "calc(50% - 6px)", // Adjusted to divide into two equal parts
                    display: "flex", // Ensure content inside is aligned
                    justifyContent: "space-between", // Space between label and value
                    marginBottom: "8px", // Add some margin to separate rows
                  }}
                >
                  <Typography
                    sx={{ fontWeight: "400", color: "#9FA4AB" }}
                    variant="body1"
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between", // Ensures the content is split equally
                      alignItems: "center", // Align items vertically
                    }}
                  >
                    <Box
                      sx={{ width: "50%", fontWeight: 500, textAlign: "left" }}
                    >
                      {bank.columnName}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "52%",
                        justifyContent: "space-between", // Align content properly even if no icon
                      }}
                    >
                      <span
                        style={{
                          color: "#3B3B3B",
                          fontWeight: 500,
                          textAlign: "left",
                          // width: "40%",
                          marginRight: "8px", // Small margin between the value and icon
                        }}
                      >
                        <span style={{ marginRight: "10px" }}>: </span>{" "}
                        {bank.columnValues}
                      </span>
                      {bank?.isCopy ? (
                        <IconButton
                          onClick={() => handleCopy(bank.columnValues)}
                          size="small"
                          sx={{ marginRight: "auto" }}
                        >
                          <img
                            src={Copy}
                            alt="copy icon"
                            height={20}
                            width={20}
                          />
                        </IconButton>
                      ) : (
                        <div style={{ width: "20px" }} /> // Leave space when no copy icon
                      )}
                    </Box>
                  </Typography>
                </div>
              ))}
            </div>
          </Box>
        )}
        <Box
          style={{ fontWeight: 500 }}
          fontSize={17}
          color={textColor.fontColor}
        >
          <span style={{ fontWeight: 700 }}> Step 2 </span>: Enter wire transfer
          details
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: "1rem", md: 16 },
            color: textColor.fontColor,
            mb: 1,
            fontWeight: 400,
            // textAlign: "center",
          }}
        >
          If you completed the wire transfer, enter the value and upload proof
          of wire transfer confirmation. We will verify the transaction and
          notify you within 2 business days
        </Typography>
        <Box sx={{ mb: 1 }}>
          <TextField
            fullWidth
            variant="outlined"
            // size="small"
            // label="Amount"
            placeholder="Amount Transferred"
            value={amount}
            onChange={handleAmountChange}
            error={error}
            helperText={
              error ? "Please enter a valid amount greater than $0" : ""
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box
                    sx={{
                      marginBottom: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 45,
                      width: 22,
                      borderRadius: "4px",
                    }}
                  >
                    <Typography sx={{ fontSize: "1.2rem" }}>$</Typography>
                  </Box>
                </InputAdornment>
              ),
            }}
            sx={{
              // mb: 3,
              height: 54,
              mb: 0,
              fontWeight: 700,
              "& input": {
                fontWeight: 600,
                bgcolor: "#fff",
                ml: "2px",
                pl: 1,
              },
              "&.MuiFormControl-root label": {
                color: textColor.fontColor,
                // ml: 2
              },
              backgroundColor: "#f9f9f9",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#ccc",
                },
                "&:hover fieldset": {
                  borderColor: "#999",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#666",
                },
              },
              "& .MuiFormHelperText-root": {
                fontSize: "0.75rem", // Ensure it matches the default height (or adjust based on your need)
                height: 25, // Set the height of the helper text
                marginTop: "4px", // Optionally adjust margin to align with the input box
              },
            }}
          />
          <Typography
            sx={{
              fontSize: "12px",
              color: textColor.fontColor,
              fontWeight: 400,
              mt: "3px",
              maxHeight: 35,
              textAlign: "left",
              fontStyle: "italic",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {numberToWords(amount?.replace(/,/g, ""))}
            {amount?.replace(/,/g, "") > 0 && " dollars"}
          </Typography>
        </Box>
        {!file?.name ? (
          <Box
            onClick={handleClick}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            sx={{
              border: `2px dashed ${textColor.borderColor}`,
              borderRadius: "8px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <input
              type="file"
              id={"type"}
              accept=".jpeg,.png,.pdf"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e)}
            />
            <IconButton sx={{ backgroundColor: "#F5F5F5", my: 1 }}>
              <CloudUploadOutlinedIcon
                sx={{ color: "#FF5C39", fontSize: "24px" }}
              />
            </IconButton>
            <Typography
              fontSize={17}
              fontWeight={500}
              my={1}
              px={1}
              color={textColor.fontColor}
            >
              Click to upload wire transfer receipt OR Drag & drop it here
            </Typography>
            <Typography
              fontSize={14}
              fontWeight={400}
              mb={3}
              color={textColor.fontColor}
            >
              .jpeg, .png, or .pdf. Maximum 5MB.
            </Typography>
          </Box>
        ) : (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            bgcolor={textColor.secondaryColor}
            mb={1}
            p={1}
            // width={2}
            borderRadius="4px"
          >
            <Typography fontSize={14} color="text.secondary">
              {file.name} ({(file.size / 1024).toFixed(2)} KB)
            </Typography>
            <Box sx={{ display: "flex", gap: 2, fontSize: 14, width:'9rem' }}>
              <img src={uploadDone} alt="upload" width={20} height={20} />
              Uploaded
              <div
                onClick={() => {
                  setFiles({});
                }}
              >
                <img src={trash} alt="upload" width={20} height={20} />
              </div>
            </Box>
          </Box>
        )}
        <Box textAlign="center">
          <ButtonComponents
            label={"Submit"}
            onClick={handleAddFundsBank}
            disabled={!(file?.name && amount) || error}
            variant="contained"
            sx={{
              fontSize: 14,
              mb: 4,
              // color: "#fff",
              my: "10px",
              height: 40,
              borderRadius: 2,
              "&:hover": {
                boxShadow: "none",
              },
            }}
          />
        </Box>
        <Box
          sx={{
            backgroundColor: "#FAFAFA",
            p: 2,
            mt: 1,
            borderRadius: 1,
            textAlign: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "#666" }}>
          Skip for now, explore
            <Link
              href="/search"
              underline="none"
              sx={{
                color: textColor.primaryColor,
                fontWeight: "600",
                mx: 1,
                textDecoration: "Underline",
              }}
            >
              foreclosure properties
            </Link>
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default AddFundsBank;
